export enum SupervisoryReviewQuestionnaireItem {
  SUPERVISORY_REVIEW_ID_BADGE = 'supervisory-review/id-badge',
  SUPERVISORY_REVIEW_HONORING_RIGHTS = 'supervisory-review/honoring-rights',
  SUPERVISORY_REVIEW_EMERGENCY_PROTOCOL = 'supervisory-review/emergency-protocol',
  SUPERVISORY_REVIEW_HYGIENE_PRECAUTIONS = 'supervisory-review/hygiene-precautions',
  SUPERVISORY_REVIEW_REPORTING_CHANGES = 'supervisory-review/reporting-changes',
  SUPERVISORY_REVIEW_GRIEVANCE_COMPLAINT = 'supervisory-review/grievance-complaint',
  SUPERVISORY_REVIEW_POC_DOC_REVIEWED_WITH_CAREGIVER = 'supervisory-review/poc-doc-reviewed-with-caregiver',
  SUPERVISORY_REVIEW_PPE_ACCESS = 'supervisory-review/ppe-access',
  SUPERVISORY_REVIEW_SUPERVISION_OBSERVED = 'supervisory-review/supervision-observed',
  SUPERVISORY_REVIEW_TASK_OBSERVED = 'supervisory-review/task-observed',
  SUPERVISORY_REVIEW_PATIENT_STATUS = 'supervisory-review/patient-status',
  SUPERVISORY_REVIEW_COMMENTS = 'supervisory-review/comments'
}
